import React from "react";
import { guide, testimonials } from "../mock";
import Reveal from "./Reveal";
import { Mail, Phone, Quote } from "lucide-react";

const Guide = () => {
  return (
    <section id="guide" className="section bg-[#1a3a2e] relative overflow-hidden">
      <div className="absolute inset-0 opacity-[0.04] pointer-events-none" style={{
        backgroundImage: "radial-gradient(circle at 1px 1px, #c9a55c 1px, transparent 0)",
        backgroundSize: "36px 36px"
      }} />
      <div className="max-w-7xl mx-auto px-6 lg:px-10 relative">
        <div className="grid lg:grid-cols-2 gap-16 lg:gap-20 items-center">
          <Reveal>
            <div className="relative">
              <div
                className="w-full aspect-[4/5] max-w-md bg-cover bg-center rounded-sm shadow-2xl"
                style={{ backgroundImage: `url(${guide.image})` }}
              />
            </div>
          </Reveal>

          <Reveal delay={150}>
            <div>
              <span className="font-script text-[#e9c987] text-3xl block mb-2">meet your guide</span>
              <h2 className="font-display text-[#faf5ec] text-4xl md:text-5xl mb-2">
                Hi, I&rsquo;m <em className="italic text-[#e9c987]">{guide.name.split(" ")[0]}</em>.
              </h2>
              <p className="text-[#e9c987]/90 text-[11px] tracking-[0.3em] uppercase mb-6">{guide.role}</p>

              <div className="space-y-4">
                {guide.bio.map((p, i) => (
                  <p key={i} className="text-[#faf5ec]/85 leading-relaxed font-light text-[15.5px]">
                    {p}
                  </p>
                ))}
              </div>

              <div className="mt-8 flex flex-wrap gap-4">
                <a href={`mailto:${guide.email}`} className="inline-flex items-center gap-2 text-[#e9c987] hover:text-[#faf5ec] transition-colors text-sm">
                  <Mail className="w-4 h-4" strokeWidth={1.5} /> {guide.email}
                </a>
                <a href={`tel:${guide.phone}`} className="inline-flex items-center gap-2 text-[#e9c987] hover:text-[#faf5ec] transition-colors text-sm">
                  <Phone className="w-4 h-4" strokeWidth={1.5} /> {guide.phone}
                </a>
              </div>

              {/* Gallery thumbnails */}
              {guide.gallery && (
                <div className="mt-10 grid grid-cols-3 gap-3 max-w-md">
                  {guide.gallery.map((img, i) => (
                    <div
                      key={i}
                      className="aspect-[3/4] bg-cover bg-center rounded-sm shadow-lg ring-1 ring-[#faf5ec]/10 hover:ring-[#e9c987]/60 transition-all duration-300 hover:-translate-y-1"
                      style={{ backgroundImage: `url(${img})` }}
                    />
                  ))}
                </div>
              )}
            </div>
          </Reveal>
        </div>

        {/* Testimonials */}
        <div className="mt-24">
          <Reveal>
            <div className="text-center mb-10">
              <span className="font-script text-[#e9c987] text-3xl block mb-1">kind words</span>
              <h3 className="font-display text-[#faf5ec] text-3xl md:text-4xl">
                Real <em className="italic text-[#e9c987]">Reviews</em> from Last Year&rsquo;s Group
              </h3>
            </div>
          </Reveal>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
            {testimonials.slice(0, 6).map((t, idx) => (
              <Reveal key={idx} delay={idx * 80}>
                <div className="bg-[#faf5ec]/8 border border-[#faf5ec]/15 backdrop-blur-sm p-7 rounded-sm h-full hover:border-[#e9c987]/40 transition-colors">
                  <Quote className="w-6 h-6 text-[#e9c987] mb-3" strokeWidth={1.5} />
                  <p className="text-[#faf5ec] text-[16px] leading-relaxed font-normal mb-5">
                    &ldquo;{t.quote}&rdquo;
                  </p>
                  <div className="pt-4 border-t border-[#faf5ec]/15">
                    <p className="text-[#e9c987] text-base font-semibold tracking-wide">{t.name}</p>
                    <p className="text-[#faf5ec]/70 text-xs mt-0.5">{t.trip}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Guide;
